import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import Siema from 'v-siema';
import VueMasonry from 'vue-masonry-css'

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.use(Siema);
Vue.use(VueMasonry);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(VueLazyload)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
